import * as React from 'react';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';


const marks = [
    {
        value: 0,
    },
    {
        value: 1,
    },
    {
        value: 2,
    },
];

export default function Slider3PosComponent() {
    return (
        <Box sx={{ width: 140 }}>
            <Slider
                track={false}
                aria-labelledby="track-false-slider"
                defaultValue={2}
                marks={marks}
                max={2}
                min={0}
                disabled
                sx={{
                    '& .MuiSlider-rail': {
                        backgroundColor: 'blue',
                    },
                    '& .MuiSlider-thumb': {
                        backgroundColor: '#999',
                    },
                }}
            />
        </Box>
    );
}
